import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {RadioButton} from '../../../../../libs/shared/ui/src/components/booleanInputs/radioButton';
import {FlexWrapper} from '../../../../../libs/shared/ui/src/storybook/storybookLayoutHelpers';
import {RecurringEventSaveTypesEnum} from '../../../../store/data/calendarEventVersions/calendarEventVersionsActions';

/*
 * Props.
 */

interface RecurringSaveTypeSelectorProps {
  recurringSaveType: RecurringEventSaveTypesEnum;
  onChange: HandlerOf<RecurringEventSaveTypesEnum>;
}

/*
 * Component.
 */

export const RecurringSaveTypeSelector: FC<RecurringSaveTypeSelectorProps> = ({
  recurringSaveType,
  onChange,
}) => (
  <FlexWrapper margin={5} direction="column">
    <RadioButton
      onChange={() => onChange(RecurringEventSaveTypesEnum.INSTANCE)}
      isChecked={recurringSaveType === RecurringEventSaveTypesEnum.INSTANCE}
    >
      <Trans id="recurring-save-dialog-instance">This event</Trans>
    </RadioButton>
    {/* <RadioButton
      onChange={() => props.onChange(RecurringEventSaveTypesEnum.FUTURE_EVENTS)}
      isChecked={props.recurringSaveType === RecurringEventSaveTypesEnum.FUTURE_EVENTS}
    >
      <Trans id="recurring-save-dialog-future">This and all future events</Trans>
    </RadioButton> */}
    <RadioButton
      onChange={() => onChange(RecurringEventSaveTypesEnum.ENTIRE_SERIES)}
      isChecked={recurringSaveType === RecurringEventSaveTypesEnum.ENTIRE_SERIES}
    >
      <Trans id="recurring-save-dialog-series">All events in the series</Trans>
    </RadioButton>
  </FlexWrapper>
);
